export enum VerificationStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum draftStatus {
  OPEN = "open",
  COMPELETED = "completed",
}